// A fixed, ordered categorical palette for series the backend cannot label
// with a design-fixed color (an arbitrary book, state or team name — unlike
// a fixed enum such as a distribution method or a response rating, which
// keep their own approved swatch in constants/tspOperations.js).
//
// The values are exactly the swatches already approved across the TSP mocks
// (Distribution Summary's "By Book Type", Live Ranking's team colors, the
// State Wise table) — this only makes them reusable in a fixed order instead
// of hand-picked per screen, so the same Nth item always gets the same color.
export const TSP_CATEGORICAL_PALETTE = [
  "#E07B1A",
  "#3D9BD0",
  "#2FA96A",
  "#6C4FD6",
  "#F3B01B",
  "#C588AC",
  "#5B6ACF",
  "#9F1D21",
  "#14B8A6",
  "#D96C6C",
];

// Deterministic: item N always gets the same color regardless of how many
// items are on screen (cycles past the end rather than repeating the whole
// palette from a different offset).
export function colorForIndex(index) {
  return TSP_CATEGORICAL_PALETTE[index % TSP_CATEGORICAL_PALETTE.length];
}

export function withSeriesColors(items, key = "name") {
  return items.map((item, index) => ({ ...item, color: item.color || colorForIndex(index) }));
}
